module.exports = __webpack_public_path__ + "img/273-checkmark.d344acb7.svg";